// extracted by mini-css-extract-plugin
export default {"formContainer":"Form_formContainer__GGwfY","error":"Form_error__Gils1","success":"Form_success__LZB53"};